import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AdminAuthProvider } from './AdminAuthContext';
import ProtectedRoute from './ProtectedRoute';
import AdminLayout from './AdminLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import MoviesPage from './pages/MoviesPage';
import SubscribersPage from './pages/SubscribersPage';
import AnalyticsPage from './pages/AnalyticsPage';
import CategoriesPage from './pages/CategoriesPage';
import SliderPage from './pages/SliderPage';

export default function AdminApp() {
  return (
    <AdminAuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route element={<ProtectedRoute />}>
          <Route element={<AdminLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="movies" element={<MoviesPage />} />
            <Route path="collections" element={<CategoriesPage />} />
            <Route path="categories" element={<Navigate to="/collections" replace />} />
            <Route path="homepage-slider" element={<SliderPage />} />
            <Route path="subscribers" element={<SubscribersPage />} />
            <Route path="analytics" element={<AnalyticsPage />} />
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AdminAuthProvider>
  );
}
